<template>
  <div class="count-down">
    <span class="time">{{ hour > 9 ? '' : '0' }}{{ hour }}</span>
    <span class="split">:</span>
    <span class="time minute">{{ minute > 9 ? '' : '0' }}{{ minute }}</span>
    <span class="split">:</span>
    <span class="time second">{{ second > 9 ? '' : '0' }}{{ second }}</span>
  </div>
</template>

<script lang="ts">
/* eslint-disable @typescript-eslint/no-magic-numbers */

import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
export interface IConfig {
  time: number;
}
@Component({})
export default class CountDown extends Vue {
  @Prop({
    type: Object,
    default: () => {
      return { time: 0 };
    },
  })
  config!: IConfig;

  timestamp = 0;

  intervalFlag: any;
  get hour() {
    return Math.floor(this.timestamp / 3600);
  }

  get minute() {
    return Math.floor((this.timestamp - this.hour * 3600) / 60);
  }

  get second() {
    return Math.floor(this.timestamp - this.hour * 3600 - this.minute * 60);
  }
  created() {
    this.countDownHandle = this.countDownHandle.bind(this);
    this.$on('stop', this.stop);
    this.$on('start', this.start);
  }
  mounted() {
    this.timestamp = this.config && this.config.time;
    this.start();
  }
  countDownHandle() {
    if (this.timestamp > 0) {
      this.timestamp = this.timestamp - 1;
      this.$emit('next', this.timestamp);
    } else if (this.intervalFlag) {
      clearInterval(this.intervalFlag);
      this.$emit('finish');
    }
  }
  start() {
    clearInterval(this.intervalFlag);
    if (this.timestamp > 0) {
      this.intervalFlag = setInterval(this.countDownHandle, 1000);
    }
  }
  stop() {
    if (this.intervalFlag) {
      clearInterval(this.intervalFlag);
    }
  }

  @Watch('config')
  oninitTimeChanged(val: IConfig, oldVal: IConfig) {
    if (val && val.time > 0) {
      this.timestamp = val.time;
      this.start();
    }
  }
  beforeDestroy() {
    this.stop();
  }
}
</script>

<style lang="scss" scoped>
.count-down {
  display: flex;
  align-items: center;
  // color: rgba($color: #2f2f2f, $alpha: 0.68);
  color: #fff;
  font-weight: 600;
  font-size: 71px;
  line-height: 1;
  .time {
    display: inline-block;
  }
}
</style>
